export type LinkAction = { type: 'link'; href: string };

interface PromoAvailability {
    from?: Date;
    until: Date;
}

export interface PromoEvent {
    id: string;
    availability: PromoAvailability;
    sortAt?: Date;
    badge: string;
    day?: string;
    month?: string;
    time?: string;
    title: string;
    desc: string;
    ctaLabel: string;
    action: LinkAction;
    moreTherapyId?: string;
}

export const buildTherapyHref = (therapyId: string) => `/?therapy=${encodeURIComponent(therapyId)}#page-therapies`;

const atLocalTime = (year: number, month: number, day: number, hour = 0, minute = 0) =>
    new Date(year, month - 1, day, hour, minute, 0, 0);

const endOfDay = (year: number, month: number, day: number) =>
    new Date(year, month - 1, day, 23, 59, 59, 999);

export const PROMO_EVENTS: PromoEvent[] = [
    {
        id: 'sonder-aktion',
        availability: {
            until: endOfDay(2026, 4, 6),
        },
        badge: 'Sonder-Aktion - nur bis Ostern',
        title: '3x SANZA-Termin - 70 % Rabatt',
        desc: 'Inkl. je 2 HRV-Messungen vor & nach. Statt 240,- EUR nur 72,- EUR - Termine begrenzt!',
        ctaLabel: 'Jetzt sichern',
        action: { type: 'link', href: '#page-booking' },
        moreTherapyId: 'sanza',
    },
    {
        id: 'family-day-march',
        availability: {
            until: endOfDay(2026, 3, 22),
        },
        sortAt: atLocalTime(2026, 3, 22, 10, 0),
        badge: 'Nächste Veranstaltung',
        day: '22',
        month: 'März',
        title: 'SANZA Family Day',
        desc: 'Einmaliges Familienevent - SANZA Behandlung + Einweisung & Nachgespräch - Standort Regensburg',
        ctaLabel: 'Platz sichern',
        action: { type: 'link', href: '#page-contact' },
        moreTherapyId: 'sanza',
    },
    {
        id: 'webinar-april',
        availability: {
            until: atLocalTime(2026, 4, 8, 20, 0),
        },
        sortAt: atLocalTime(2026, 4, 8, 20, 0),
        badge: 'Live-Webinar',
        day: '8',
        month: 'April',
        time: '20:00 Uhr',
        title: 'SANZA Live-Webinar',
        desc: 'Mit Firmengründer Christian Pichler - "Die Kraft der Natur trifft High-Tech" - kostenlos, online',
        ctaLabel: 'Anmelden',
        action: { type: 'link', href: 'https://go.sanzanet.com/live-webinar-2024?utm_source=hploewe' },
    },
    {
        id: 'info-abend-april',
        availability: {
            until: atLocalTime(2026, 4, 17, 17, 0),
        },
        sortAt: atLocalTime(2026, 4, 17, 17, 0),
        badge: 'Info- & Erlebnis-Abend',
        day: '17',
        month: 'April',
        time: '17:00-20:30 Uhr',
        title: 'SANZA Erlebnis-Abend',
        desc: 'SANZA live erleben (1 Anwendung gratis!) + Vortrag + Fragen & Antworten - Standort Regensburg',
        ctaLabel: 'Platz sichern',
        action: { type: 'link', href: '#page-contact' },
        moreTherapyId: 'sanza',
    },
    {
        id: 'family-day-april',
        availability: {
            until: endOfDay(2026, 4, 26),
        },
        sortAt: atLocalTime(2026, 4, 26, 10, 0),
        badge: 'Nächste Veranstaltung',
        day: '26',
        month: 'April',
        title: 'SANZA Family Day',
        desc: 'SANZA für die ganze Familie (auch Vierbeiner willkommen!) - 60 % Rabatt - Standort Regensburg',
        ctaLabel: 'Platz sichern',
        action: { type: 'link', href: '#page-contact' },
        moreTherapyId: 'sanza',
    },
];

export const isPromoEventActive = (event: PromoEvent, now: Date = new Date()) => {
    const { from, until } = event.availability;
    return (!from || now >= from) && now <= until;
};

export const getActivePromoEvents = (now: Date = new Date()) =>
    PROMO_EVENTS
        .filter((event) => isPromoEventActive(event, now))
        .sort((left, right) => {
            const leftDate = left.sortAt ?? left.availability.until;
            const rightDate = right.sortAt ?? right.availability.until;
            return leftDate.getTime() - rightDate.getTime();
        });